import React from 'react';

/**
 * The app's logo mark, rendered from the brand file.
 *
 * Annotation pass 2: the sidebar, the phone top bar and the boot screen each
 * built the mark out of a gradient `<span class="logo-mark">` with the layered
 * glyph inlined — the same glyph as `public/logo.svg`, but on Variant C's
 * teal→indigo gradient rather than the brand's teal→green. Three copies of a
 * near-miss. This renders the real file instead, so there is one definition of
 * the logo and it lives where a designer can replace it.
 *
 * Three marks exist now, and each is the right one somewhere:
 *
 * - `logo.svg` — the brand file. Its glyph fills 66.6% of the tile, which is
 *   what reads at 16–32px, so this is what the favicon, the manifest and the
 *   PWA install icon use.
 * - `logo_app.svg` — **this one.** Variant C's proportions (a 22px glyph in a
 *   40px tile, 12px radius) with the brand's teal→green gradient. At 40px it is
 *   the demo's mark exactly, which the brand file at the same size is not: same
 *   footprint, a third more glyph inside it.
 * - `logo_alt.svg` — the demo's own teal→indigo mark, kept for whatever wants it.
 *
 * `.logo-mark` keeps its size, radius and glow; the `brand` refinement in
 * overrides.css drops the CSS gradient underneath, which would otherwise show
 * through the file's own rounded corners.
 *
 * Decorative: every site that renders it also renders the "Fiwara" wordmark
 * beside it, so an alt text here would just be read out twice.
 */
const AppLogo = React.memo(function AppLogo({ className = '' }) {
    return (
        <img
            className={`logo-mark brand ${className}`.trim()}
            src={`${process.env.PUBLIC_URL}/logo_app.svg`}
            alt=""
            draggable="false"
        />
    );
});

export default AppLogo;
